import {
  GET_AMEND_MANUAL_ORDERS_REQUEST,
  GET_AMEND_MANUAL_ORDERS_SUCCESS,
  GET_AMEND_MANUAL_ORDERS_ERROR,
  RESET_AMEND_MAUAL_ORDERS,
  UPDATE_AMEND_MANUAL_ORDERS,
} from "redux/actions/action-type";

const initialState = {
  isManualOrdersError: false,
  isManualOrdersSuccess: false,
  isManualOrdersLoading: false,
  orders: [],
  metadata: [],
  errorDetails: {},
};

const manualOrdersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_AMEND_MANUAL_ORDERS_REQUEST:
      return {
        ...state,
        isManualOrdersLoading: true,
        isManualOrdersSuccess: false,
        isManualOrdersError: false,
      };
    case GET_AMEND_MANUAL_ORDERS_SUCCESS:
      const { orders: newOrders, metadata: newMetadata } = payload;
      const { orders: existingOrders } = state;
      let mergedOrders;
      if (existingOrders) {
        mergedOrders = [...existingOrders, ...newOrders];
      } else {
        mergedOrders = newOrders;
      }

      return {
        ...state,
        orders: mergedOrders,
        metadata: newMetadata,
        errorDetails: {},
        isManualOrdersLoading: false,
        isManualOrdersSuccess: true,
        isManualOrdersError: false,
      };
    case GET_AMEND_MANUAL_ORDERS_ERROR:
      return {
        ...state,
        errorDetails: payload,
        isManualOrdersLoading: false,
        isManualOrdersSuccess: false,
        isManualOrdersError: true,
      };
    case RESET_AMEND_MAUAL_ORDERS:
      return initialState;

    case UPDATE_AMEND_MANUAL_ORDERS:
      const { orders } = payload;
      const { metadata } = state;
      return {
        ...state,
        orders: orders,
        metadata: metadata,
        isManualOrdersLoading: false,
        isManualOrdersSuccess: true,
        isManualOrdersError: false,
      };
    default:
      return state;
  }
};

export default manualOrdersReducer;
